<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row no-gutters>
            <v-col 
                v-for="week in weeks" 
                cols="4" 
                class="text-center table-head primary--text" 
                :key="week"
                v-on:click="$emit('ordering', week)"
            >
                <div v-if="ordered_week == week">
                    {{week}} {{order_symbol}}
                </div>
                <div v-else>
                    {{week}}
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    props: {
        weeks: {
            type: [Object, Array],
            required: true,
        },
        ordered_week: {
            type: String,
            required: false,
            default: '',
        },
        order_symbol: {
            type: String,
            required: false,
            default: '',
        },
    },
    // methods: {
    //     aux(week) {
    //         console.log(week)
    //     }
    // }
};
</script>

<style scoped>
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;
        border-color:#663399;
        border-width: thin;
    }
</style>